/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

const newAddressForm = document.getElementById('AddressNewForm');

let Shopify = window.Shopify || {};

if (newAddressForm) {
  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew',
    });
  }

  // Initialize each edit form's country/province selector
  document.querySelectorAll('.address-country-option').forEach(function (element) {
    const formId = element.dataset.formId;
    const countrySelector = `AddressCountry_${formId}`;
    const provinceSelector = `AddressProvince_${formId}`;
    const containerSelector = `AddressProvinceContainer_${formId}`;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector,
    });
  });

  // Toggle new/edit address forms
  document.querySelector('.address-new-toggle').addEventListener('click', () => {
    newAddressForm.classList.toggle('hide');
  });

  document.querySelectorAll('.address-edit-toggle').forEach(function (element) {
    element.addEventListener('click', function () {
      const formId = this.dataset.formId;
      document.getElementById(`EditAddress_${formId}`).classList.toggle('hide');
    });
  });

  document.querySelectorAll('.address-delete').forEach(function (element) {
    element.addEventListener('click', function () {
      const formId = this.dataset.formId;
      const confirmMessage = this.dataset.confirmMessage;
      if (window.confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
        Shopify.postLink(`/account/addresses/${formId}`, {
          parameters: {
            _method: 'delete',
          },
        });
      }
    });
  });
}
